export default __webpack_public_path__ + "static/media/IMG_1976.cbc051a3.JPG";